module.exports = __webpack_public_path__ + "img/010-011.b671dc2a.jpg";